<template>


  <div class="">


<!-- 
    <header class="header">
        <div class="container">


      <nav v-if="headFoot" id="top-menu" class="navbar navbar-expand-xxl navbar-light py-1 py-xxl-1 sticky-top">
        <div class="container">
          <a class="navbar-brand" @click="goToMainPage" href="#">

          </a>
          <div>
              
                <button class="navbar-toggler" v-on:click='isOpen = !isOpen'>
                  <span class="navbar-toggler-icon"></span>
                </button>
          </div>



          <div class="navbar-collapse" v-show="isOpen">


            <div class="ms-xl-auto">
              <a v-if="loggedIn && !isClientV"  class="d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click="gotoclient" >Strefa klienta </a>
              <a v-if="!loggedIn" class="btn btn-outline-primary btn-lg me-2" @click="" data-bs-toggle="modal" data-bs-target="#loginDialog" id="login-button"  v-on:click='isOpen = !isOpen'>Zaloguj się </a>
              <a v-if="loggedIn" class="login-button btn btn-outline-primary btn-lg me-2" @click="doLogout" > Wyloguj </a>

            </div>

          </div>



        </div>
      </nav>


        </div>
    </header>



 -->






<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-dark-grayscale"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0 0.49803921568627"></fefuncr><fefuncg type="table" tablevalues="0 0.49803921568627"></fefuncg><fefuncb type="table" tablevalues="0 0.49803921568627"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-grayscale"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0 1"></fefuncr><fefuncg type="table" tablevalues="0 1"></fefuncg><fefuncb type="table" tablevalues="0 1"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-purple-yellow"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0.54901960784314 0.98823529411765"></fefuncr><fefuncg type="table" tablevalues="0 1"></fefuncg><fefuncb type="table" tablevalues="0.71764705882353 0.25490196078431"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-blue-red"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0 1"></fefuncr><fefuncg type="table" tablevalues="0 0.27843137254902"></fefuncg><fefuncb type="table" tablevalues="0.5921568627451 0.27843137254902"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-midnight"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0 0"></fefuncr><fefuncg type="table" tablevalues="0 0.64705882352941"></fefuncg><fefuncb type="table" tablevalues="0 1"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-magenta-yellow"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0.78039215686275 1"></fefuncr><fefuncg type="table" tablevalues="0 0.94901960784314"></fefuncg><fefuncb type="table" tablevalues="0.35294117647059 0.47058823529412"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-purple-green"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0.65098039215686 0.40392156862745"></fefuncr><fefuncg type="table" tablevalues="0 1"></fefuncg><fefuncb type="table" tablevalues="0.44705882352941 0.4"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 0 0" width="0" height="0" focusable="false" role="none" style="visibility: hidden; position: absolute; left: -9999px; overflow: hidden;"><defs><filter id="wp-duotone-blue-orange"><fecolormatrix color-interpolation-filters="sRGB" type="matrix" values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "></fecolormatrix><fecomponenttransfer color-interpolation-filters="sRGB"><fefuncr type="table" tablevalues="0.098039215686275 1"></fefuncr><fefuncg type="table" tablevalues="0 0.66274509803922"></fefuncg><fefuncb type="table" tablevalues="0.84705882352941 0.41960784313725"></fefuncb><fefunca type="table" tablevalues="1 1"></fefunca></fecomponenttransfer><fecomposite in2="SourceGraphic" operator="in"></fecomposite></filter></defs></svg><div id="page" class="site thsn-parent-header-style-1">
  <a class="skip-link screen-reader-text" href="#content">Skip to content</a>
  <header id="masthead" class="site-header thsn-header-style-1">
  <div class="thsn-header-height-wrapper" style="min-height:110px;">
  <div class="thsn-sticky-logo-no thsn-responsive-logo-yes thsn-header-wrapper thsn-bg-color-white ">
    <div class="container">




      <div class="d-flex justify-content-between align-items-center">



        <div class="thsn-logo-menuarea">
          <div class="site-branding thsn-logo-area">
            <div class="wrap">
              <h1 class="site-title"><a href="https://www.minicredit.pl/" rel="home"><span class="site-title-text">Mini-credit.pl - Szybka pożyczka bez zbędnych formalności na Mini-Credit.pl</span>
                <img class="thsn-main-logo" src="static/wp-content/uploads/2022/08/pod-www-color-napisy.png" alt="Mini-credit.pl" title="Mini-credit.pl">
                <img class="thsn-responsive-logo" src="static/wp-content/uploads/2022/08/pod-www-color-napisy.png" alt="Mini-credit.pl" title="Mini-credit.pl"></a></h1>
<!-- Logo area -->
            </div>
<!-- .wrap -->
          </div>
<!-- .site-branding -->
        </div>



          <!-- Top Navigation Menu -->
          <div class="navigation-top">
            <div class="thsn-mobile-search">
            </div>
            <button id="menu-toggle" class="nav-menu-toggle">
              <i class="thsn-base-icon-menu-1"></i>
            </button>
              <div class="wrap">
                <nav id="site-navigation" class="main-navigation thsn-navbar  thsn-main-active-color-globalcolor thsn-sticky-main-active-color-globalcolor thsn-dropdown-active-color-globalcolor" aria-label="Top Menu">
                  <div class="menu-main-menu-container"><ul id="thsn-top-menu" class="menu">
<li id="menu-item-13180" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-10938 current_page_item menu-item-13180"><a href="https://www.minicredit.pl/" aria-current="page">Start</a></li>
<li id="menu-item-13519" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13519"><a href="https://www.minicredit.pl/o-nas/">O NAS</a></li>
<li id="menu-item-13543" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13543"><a href="https://www.minicredit.pl/wez-pozyczke/">Weź pożyczkę</a></li>
<li id="menu-item-13565" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13565"><a href="https://www.minicredit.pl/splata-pozyczki/">Spłata pożyczki</a></li>
<li id="menu-item-13176" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13176"><a href="https://www.minicredit.pl/faq/">FAQ</a></li>
<li id="menu-item-13589" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-13589"><a href="https://www.minicredit.pl/kontakt/">Kontakt</a></li>



<li v-if="!loggedIn" class="menu-item menu-item-type-post_type menu-item-object-page thsn-mobile-search"><a href="javascript:void(0);"  @click='gotologin(); isOpen = !isOpen'>Zaloguj</a></li>
<li v-if="loggedIn && !isClientV"  class="menu-item menu-item-type-post_type menu-item-object-page thsn-mobile-search"><a href="javascript:void(0);"  @click="gotoclient" >Strefa klienta</a></li>
<li v-if="loggedIn" class="menu-item menu-item-type-post_type menu-item-object-page thsn-mobile-search"><a href="javascript:void(0);" @click="doLogout">Wyloguj</a></li>


</ul></div>               </nav><!-- #site-navigation -->
              </div>
<!-- .wrap -->
          </div>
<!-- .navigation-top -->
        
        <div class="thsn-right-box">    

          <div class="thsn-header-button">
              <a v-if="!loggedIn || isRegisterLink" class="btn btn-outline-primary btn-lg me-2" href="javascript:void(0);"   @click='gotologin(); isOpen = !isOpen'>Zaloguj</a>

              <a v-if="loggedIn && !isClientV && !isRegisterLink"  class="d-none d-xxl-inline-block btn btn-outline-primary me-2" href="javascript:void(0);" @click="gotoclient" >Strefa klienta </a>

              <a v-if="loggedIn && !isRegisterLink" class=" btn btn-outline-primary btn-lg me-2" href="javascript:void(0);" @click="doLogout" > Wyloguj </a>

          </div>



                    
        </div>
      </div>
<!-- .justify-content-between -->
    </div>
<!-- .container -->
  </div>
<!-- .thsn-header-wrapper -->
</div>
<!-- .thsn-header-height-wrapper -->
  </header><!-- #masthead -->
  <div class="site-content-contain ">
    <div class="site-content-wrap">
      <div id="content" class="site-content container">
                        <div class="thsn-header-search-form-wrapper">
          <div class="thsn-search-close"><i class="thsn-base-icon-cancel"></i></div>
                    <form role="search" method="get" class="search-form" action="./">
            <label for="search-form-62fe0dff45b10">
              <span class="screen-reader-text">Search for:</span>
            </label>
            <input type="search" id="search-form-62fe0dff45b10" class="search-field" placeholder="Write Search Keyword &amp; Press Enter" value="" name="s">
            <button type="submit" class="search-submit">Search</button>
          </form>
        </div>
<div id="primary" class="content-area ">
  <main id="main" class="site-main thsn-page-content-wrapper">
          <article id="post-10938" class="post-10938 page type-page status-publish hentry"> <!-- .entry-content -->
      </article><!-- #post-## -->
              </main><!-- #main -->
</div>
<!-- #primary -->
            </div>
<!-- #content -->
    </div>






    



    <LPopup/>
    <ForgotPassword/>


    <loading-screen :is-loading="isLoading"></loading-screen>



    <router-view></router-view>








        <!-- .site-content-main -->
<footer id="colophon" class="site-footer  thsn-footer-sep-on thsn-color-white thsn-bg-color-blackish thsn-footer-menu-no thsn-footer-widget-yes thsn-footer-2nd-widget-no">
          <div class="thsn-footer-boxes-container"><div class="container footer-wrap"><div class="row align-items-center">
            <div class="thsn-footer-boxes thsn-footer-boxes-1 col-md-12">1. Dane pożyczkodawcy
Informacje dotyczące pożyczkodawcy: Minicredit Spółka z ograniczoną odpowiedzialnością z siedzibą w Warszawie przy ul. Migdałowej 4, 02-796 Warszawa, wpisana do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS: 0000371165, NIP: 5252494263, REGON: 142694604, RIP: RIP000616, o kapitale zakładowym w wysokości 5 225 000,00 ZŁ.<br>
<br>


2. Pożyczka 2500 zł na 30 dni, RRSO wynosi 312,05%; całkowita kwota pożyczki: 2500 zł; oprocentowanie zmienne: 18,50%; całkowity koszt pożyczki: 308,56 zł, w tym: Prowizja 250,00 zł, Prowizja za obsługę 20,55 zł, Odsetki 38,01 zł; okres obowiązywania umowy: 30 dni; całkowita kwota do spłaty: 2808,56 zł. <br><br>


3.  Skutki braku spłaty 
W przypadku braku terminowej spłaty pożyczkodawca zastrzega sobie prawo do naliczania maksymalnych odsetek za opóźnienie w wysokości dwukrotności sumy stopy referencyjnej Narodowego Banku Polskiego oraz 5,5 punktów procentowych w skali roku, obowiązujących w dniu zwrotu Pożyczki zgodnie z art. 481 § 2(1) Kodeksu Cywilnego. Długoterminowy brak spłaty może skutkować również przekazaniem danych pożyczkobiorcy do Biur Informacji Gospodarczej. Pożyczkobiorca może zostać zobowiązany do pokrycia kosztów dochodzenia zwrotu Pożyczki na drodze postępowania sądowego i egzekucyjnego w przypadku ich wystąpienia.

</div>
    </div></div></div>
      
            <div class="footer-wrap thsn-footer-widget-area  thsn-bg-color-transparent">
        <div class="container">
          <div class="row">
                            <div class="thsn-footer-widget thsn-footer-widget-col-1 col-md-6 col-lg-3">
                  <aside id="block-10" class="widget-odd widget-last widget-first widget-1 widget widget_block widget_media_image">
<figure class="wp-block-image size-full"><img loading="lazy" width="435" height="149" src="static/wp-content/uploads/2022/08/pod-www-biale-napisy.png" alt="" class="wp-image-13468" srcset="static/wp-content/uploads/2022/08/pod-www-biale-napisy.png 435w, static/wp-content/uploads/2022/08/pod-www-biale-napisy-300x103.png 300w" sizes="(max-width: 435px) 100vw, 435px"></figure>
</aside>                </div>
<!-- .thsn-footer-widget -->
                              <div class="thsn-footer-widget thsn-footer-widget-col-2 col-md-6 col-lg-3">
                  <aside id="nav_menu-1" class="widget-odd widget-last widget-first widget-1 widget widget_nav_menu"><h2 class="widget-title">Kontakt</h2>
<div class="menu-kontakt-widget-container"><ul id="menu-kontakt-widget" class="menu">
<li id="menu-item-13160" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13160"><a href="https://www.minicredit.pl/kontakt/">pn-pt 8:00 – 16:00</a></li>
<li id="menu-item-13507" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13507"><a href="https://www.minicredit.pl/kontakt/">info@minicredit.pl</a></li>
<li id="menu-item-13512" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13512"><a href="https://www.minicredit.pl/kontakt/">+48 888 444 852</a></li>
</ul></div></aside>               </div>
<!-- .thsn-footer-widget -->
                              <div class="thsn-footer-widget thsn-footer-widget-col-3 col-md-6 col-lg-3">
                  <aside id="nav_menu-2" class="widget-odd widget-last widget-first widget-1 widget widget_nav_menu"><h2 class="widget-title">FAQ</h2>
<div class="menu-faq-container">
  <ul id="menu-faq" class="menu">

    <li id="menu-item-13151" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13151"><a href="https://www.minicredit.pl/splata-pozyczki/">Jak spłacić pożyczkę</a></li>

    <li id="menu-item-13152" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13152"><a href="https://www.minicredit.pl/wez-pozyczke/">Jak wziąć pożyczkę</a></li>

    <li id="menu-item-13714" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13714"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Oswiadczenie-PEP.pdf">Oświadczenie PEP</a></li>

    <li id="menu-item-13153" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13153"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Umowa-pozyczki.pdf">Umowa pożyczki</a></li>

</ul>
</div></aside>               </div>
<!-- .thsn-footer-widget -->
                              <div class="thsn-footer-widget thsn-footer-widget-col-4 col-md-6 col-lg-3">
                  <aside id="nav_menu-3" class="widget-odd widget-last widget-first widget-1 widget widget_nav_menu"><h2 class="widget-title">Dokumenty</h2>
<div class="menu-resources-menu-container">
  <ul id="menu-resources-menu" class="menu">


    <li id="menu-item-13155" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13155"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Polityka-Prywatnosci-i-pliki-Cookies.pdf">Polityka prywatności</a></li>

    <li id="menu-item-13156" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13156"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Formularz-Informacyjny.pdf">Formularz informacyjny</a></li>

    <li id="menu-item-13162" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13162"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Klauzula-informacyjna.pdf">Klauzula informacyjna</a></li>

    <li id="menu-item-13163" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-13163"><a target="_blank" rel="noopener" href="https://www.minicredit.pl/wp-content/uploads/2022/09/Regulamin-swiadczenia-uslug.pdf">Regulamin usług</a></li>

  </ul>
</div></aside>               </div>
<!-- .thsn-footer-widget -->
          </div>
<!-- .row -->
        </div>  
      </div>
      
      
      
      
    </footer><!-- #colophon -->
  </div>
<!-- .site-content-contain -->
</div>
<!-- #page -->
<a href="#" class="scroll-to-top"><i class="thsn-base-icon-up-open-big"></i></a>













  </div>
</template>

<script>


  import Loader from "./components/Loader";

  import LPopup from "./components/LoginPopup";

  import ForgotPassword from './components/ForgotPasssword';

export default {
  name: 'MCPage',

    components: {
      'loading-screen': Loader,
      LPopup,
      ForgotPassword
    },


  computed: {
//console.log('is client')
//console.log(this.$router.currentRoute.path)
  },


  data() {
    return {
      isLoading: false,
      isClientV: false,
      isLoginV: false,
      loggedIn: false,
      isOpen: false,
      isRegisterLink: false,

      headFoot: true

    }
  },


  watch:{
    $route (to){

      this.isClientV = to.path === '/client';
      this.isLoginV = to.path === '/login';


      this.log('- route go to ', to.path);

    }
  },



  methods: {

    doLogout(notoast=false){
      this.isOpen = !this.isOpen;
      // remove user from local storage to log user out
      localStorage.removeItem('user');

      this.loggedIn = false;


      this.$route.path != '/'
        && this.$router.push({path: '/'});


      !notoast
        && this.toast('Wylogowano!');
    },



    reLogin() {


      console.log('login reloaded user')

      let user = JSON.parse(localStorage.getItem('user'));

      this.post( '/client/login', {

          client_login: user.E1,
          client_password: user.E2
        })
        .then(response => {

       //   page.isLoading = false;

          if (!!response.data) {

            response.data.E1 = user.E1;
            response.data.E2 = user.E2;

            // rerset state
            this.loggedIn = response.data;

            localStorage.setItem('user', JSON.stringify(response.data));

            this.echo('login_reloaded', response.data);
          }

        })
        .catch(error => {


        });

    },



    gotoclient() {

        this.$router.push({path: '/client'}).then( success => {return success});
    },


    gotologin() {

        this.$router.push({path: '/login'});
    },



    gotothanku() {

        this.$router.push({path: '/thankyou'});
    },


    goToMainPage() {

        this.$router.push({path: '/'});
    },


    gotokontox() {


        this.$router.push({path: 'kontox'});

    },




    foobar() {


        console.log('this is is roots 1 page')
    }

  },


  created() {

    let dt = localStorage.getItem('user');

      this.listen('logged_in', (data) => {
          this.loggedIn = data;

          // logged in so clear flag
          this.isRegisterLink = false;
      });
      
      this.listen('next_step_fail', () => {
          /*console.log("elo");*/
          this.echo('ForgotPasswordModal',"stepFail");
      });


/*    this.listen('logged_in', (data) => {
      this.loggedIn = data;
    });*/



    this.get( '/session' )
    .then(response => {

      if (!!response.data) {
        let ok = !(response.data.IS_ERROR | 0);


        if ( ok && dt ) {

          this.loggedIn = JSON.parse(dt);
        }

      }
    })
    .catch(error => {

      !!dt && this.doLogout(true);
    });



    if (this.$route.path == '/pdf') {

      this.headFoot = false;
    }



    // propagate current values
    this.listen('echo_values_set', () => {
      this.echoValues();
    });


    this.listen('login_reload', () => {

      this.reLogin();
    });

  },


  mounted() {



    let uri = window.location.href.split('?');


     if (uri.length > 1 && /login/.test(uri[1]) ) {

        this.echo('login_dialog');
     }

   let uriForgotPassword = window.location.href.split('?');


    if (uri.length > 1 && /code=/.test(uriForgotPassword[1]) ) {

        let url_array = window.location.href.split('\/').join().split('?').join().split('code=')
        let tmp_token_before_regex=url_array[1]



        var tmp_token = tmp_token_before_regex.replace(/[#,]/g, "");
        /*console.log(tmp_token)*/
        this.echo('ForgotPasswordModal',tmp_token);
    }



    /*setTimeout(() => {
      this.isLoading = false
    }, 5000)*/



    /*
  .header::before {
    content: " ";
    display: block;
    width: 475px;
    height: 475px;
    background-color: #f79949;
    position: absolute;
    top: -160px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    border-radius: 50%;
  }


    */
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .header, .header .container, .header .container .header__languages ul li {
    position: relative;
  }

  a, a:hover {
    text-decoration: none;
    color: inherit;
  }

  .header .container .header__languages, .header .container .header__languages .header__phones {
    position: absolute;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }

  .header .container .header__languages .header__phones {
    font-size: 15px;
    top: -33px;
    width: 500px;
    text-align: right;
    color: #fff;
  }

  .header .container .header__languages .header__phones a:first-child {
    margin-right: 30px;
  }

  .header .container .header__languages .header__phones a {
    display: block;
  }

  .header .container .header__languages .header__phones {
    font-size: 15px;
    top: -33px;
    width: 500px;
    text-align: right;
    color: #fff;
  }

  .header .container .header__languages ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 20px;
    font-size: 14px;
    color: #fff;

    padding: 9px 15px;
    list-style:none;
  }





  .header {
    min-height: 90px;
    background-color: #fff;

    padding-top: 15px;
    padding-bottom: 10px;
  }

  .header__logo {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    max-width:250px;
    margin:0 auto;
  }

  .header__title {
    margin-top: 170px;
    font-weight: 300;
    font-size: 48px;
    color: #fff;
    text-align: center;
    position: relative;
    text-transform: uppercase;
  }


  .header__btn {
    /* display: -webkit-box; */
    /* display: -ms-flexbox; */
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 24px;
    text-transform: uppercase;
    color: #fff;
    background-color: #f79949;
    margin: 65px auto 0;
    width: 315px;
    height: 66px;
    border-radius: 33px;
    -webkit-box-shadow: 0 5px 7px 0 rgba(0,136,153,.55);
    box-shadow: 0 5px 7px 0 rgba(0,136,153,.55);
    position: relative;
    -webkit-transition: background-color .3s,-webkit-box-shadow .3s;
    -o-transition: background-color .3s,box-shadow .3s;
    /* transition: background-color .3s,box-shadow .3s; */
    transition: background-color .3s,box-shadow .3s,-webkit-box-shadow .3s;
  }





  #top-menu > div.container {

    padding-top: 0;
    padding-bottom: 0;
  }

  #top-menu div.navbar-collapse {

    padding: .5rem;
  }

  @media (min-width: 1px) {
    .wholeFooter li{
      justify-content: center;
      text-align: center;
      white-space: normal;
    }
    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 95%;
      margin-left: 2.5%;
    }
    .secondRowFooterColumn1 a{
      padding: 5px 5px;
      display: block;
    }
    .firstRowFooter li{
      padding: 5px 10px;
      display: block;
    }
  }
  @media (min-width: 400px) {
    .secondRowFooterColumn1 p{
      display: grid;
      white-space: pre-wrap;
    }
    .secondRowFooter p {
      display:flex;
    }
    .wholeFooter li{
      justify-content: center;
      text-align: center;
    }
    .firstRowFooter li{
      text-align: center;
      margin: 7px 0px;
    }
    .firstRowFooter .liUnderPic{
      margin: 15px 0px 20px;
    }
    .firstRowFooter .liUnderPic{
      margin: 15px 0px 20px;
      padding: 0;
    }
    .firstRowFooter .liUnderPic2{
      margin-bottom: 1.5em;
    }
    .secondRowFooterColumn2{
      padding-right: 15px;
      display: inline-block;
      text-align: left;

    }
    .secondRowFooterColumn1 {
      justify-content: center;
      display: flex;
    }

    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 95%;
      margin-left: 2.5%;
    }
  }
  @media(min-width: 992px){
    .secondRowFooterColumn1{
      justify-content: left;
    }
    .wholeFooter .secondRowFooter::before {
      content: "";
      background: #fff;
      position: relative;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 59vw;
      margin-left: 25.5%;
    }
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1040px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1070px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media(min-width: 1200px){
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }
  @media (min-width: 1400px) {

    .firstRowColumn li{
      white-space: nowrap;
    }
    .firstRowFooter li{
      margin: 22px 0;
      text-align: left;

    }
  }

  .wholeFooter{
    font: normal normal normal 16px/25px "Poppins";
    padding-top: 3rem;
    padding-bottom: 3rem;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #626d80;

  }
  #wholeFooter li a { margin: 0px; display: block; width: 100%; height: 100%; }
  .wholeFooter li{
    list-style: none;
    color: white;
    font-size: 16px;
    width: 100%;
  }
  .wholeFooter a{
    color: white;
    text-decoration: none;
  }
  .firstRowFooter{
    justify-content: center;

  }
  .picCol{
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
    padding-left: 0;
  }
  .firstRowColumn{
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 15px;
    padding-left: 15px;
  }
  .firstRowFooter ul{
    padding: 0;

  }


  .picCol li{
    margin: 0;

  }
  .picCol image{
    width: 117px;
    height: 50px;
  }

  .liUnderPic{
    padding-top: 1.5rem;
    padding-bottom: .5rem;
  }
  .liUnderPic2{
    margin-bottom: 1.5em;
  }
  .secondRowFooter{
    padding-top: 1.5rem!important;
  }
  .secondRowFooter a{
    margin-right: 15px;
    text-decoration: none;
    color: white;
  }
  .secondRowFooterColumn1 a{
    white-space: nowrap;
  }


  .secondRowFooterColumn2 a {
    text-align: right;
    padding-right: 14vw;
  }
  b-row{
    display: inline-block;
  }
  b-col{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/MCPage.vue